import { useMutation } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useError from '../../useError';
import useSmartlook from '../../useSmartlook';

function useClientEducationMutation() {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useMutation<
    {
      rejected: boolean;
    },
    unknown,
    UseClientEmployerMutationOptions
  >({
    mutationFn: async (payload) => {
      try {
        const resp = await fetchData('/client/education', {
          method: 'put',
          body: JSON.stringify(payload),
        });

        return resp;
      } catch (e) {
        error('[useClientEducationMutation][PUT /client/education]', e);
        showError();
        throw e;
      }
    },
  });
}

// Sort out the options
export type UseClientEmployerMutationOptions = {
  level: string;
};

export default useClientEducationMutation;
